<div class="container-body">
  <img class="login-image" src="assets/images/login-image.png" />
  <div class="vertical-aling-out">

    <div class="vertical-aling-inner">
      <div class="white-box">
        <div class="login-logo-image">
          <img src="assets/images/login-logo-image.png" />
        </div>
        <h2>Verificação em duas etapas</h2>
        <div>
          @if (!this.shippingMethodAlreadyChosen) {
            <p>Enviaremos um código de verificação para o seu telefone ou e-mail. Escolha o canal para receber o código:</p>
          }
          @if (this.shippingMethodAlreadyChosen) {
            <p>Enviamos um código de 4 dígitos para o celular cadastrado em seu usuário. Insira-o abaixo para continuar.</p>
          }
        </div>
        @if (!this.shippingMethodAlreadyChosen) {
          <div class="form">
            <div>
              <span><b>Selecione uma opção:</b></span>
              <div class="radio-options">
                <mat-radio-group aria-label="Selecione uma opção:" [(ngModel)]="chosenShippingMethod">
                  @if (this.email) {
                    <mat-radio-button [value]="supportContactTypeEnum.email">{{email}}</mat-radio-button>
                  }
                  @if (this.phone) {
                    <mat-radio-button [value]="supportContactTypeEnum.telefone">{{phone}}</mat-radio-button>
                  }
                </mat-radio-group>
              </div>
            </div>
            <div class="col-12 split-button">
              <button mat-flat-button color="primary" type="button" class="col-12 btn btn-primary btn-sm"
                (click)="sendMultiFactorAuthenticationCode()">
                @if (!isLoading) {
                  <span>Enviar código</span>
                }
                @if (isLoading) {
                  <mat-spinner [diameter]="30" class="mat-spinner-btn"></mat-spinner>
                }
              </button>
              <button mat-flat-button color="accent" type="button" class="col-12 btn btn-primary btn-sm"
                (click)="goBackLogin()">
                @if (!isLoading) {
                  <span>Voltar para o login</span>
                }
                @if (isLoading) {
                  <mat-spinner [diameter]="30" class="mat-spinner-btn"></mat-spinner>
                }
              </button>
            </div>
          </div>
        }
        @if (this.shippingMethodAlreadyChosen) {
          <div class="form">
            <span><b>Código de verificação:</b></span>
            <div class="input-code">
              <ng-otp-input
                [config]="{ length: 4, allowNumbersOnly: true }"
                (onInputChange)="optChange($event)">
              </ng-otp-input>
            </div>
            <div class="col-12 split-button">
              <button mat-flat-button color="primary" type="button" class="col-12 btn btn-primary btn-sm"
                (click)="checkMultiFactorAuthenticationCode()">
                @if (!isLoading) {
                  <span>Validar</span>
                }
                @if (isLoading) {
                  <mat-spinner [diameter]="30" class="mat-spinner-btn"></mat-spinner>
                }
              </button>
              <button mat-flat-button type="button" (click)="sendMultiFactorAuthenticationCode()"
                class="col-12 btn btn-outline-primary btn-sm" [disabled]="!this.canResend">
                @if (!isLoading && !this.canResend) {
                  <span>Reenviar o código ({{this.remainingTime}}s)</span>
                }
                @if (!isLoading && this.canResend) {
                  <span>Reenviar o código</span>
                }
                @if (isLoading) {
                  <mat-spinner [diameter]="30" class="mat-spinner-btn"></mat-spinner>
                }
              </button>
              <button mat-flat-button color="accent" type="button" class="col-12 btn btn-primary btn-sm"
                (click)="goBackLogin()">
                @if (!isLoading) {
                  <span>Voltar para o login</span>
                }
                @if (isLoading) {
                  <mat-spinner [diameter]="30" class="mat-spinner-btn"></mat-spinner>
                }
              </button>
            </div>
          </div>
        }
      </div>
    </div>
  </div>
</div>